export default __webpack_public_path__ + "static/media/baton_team_2.706af37d.jpg";